import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IProgramCategoryWithOrganizationUnit } from 'typings/api-activity';
import { IProgramCategory } from 'typings/doenkids/doenkids';
import { IProgramCategoryListState, ProgramCategoryListStore } from './program-category-list.store';

@Injectable({ providedIn: 'root' })
export class ProgramCategoryListQuery extends QueryEntity<IProgramCategoryListState, IProgramCategoryWithOrganizationUnit> {
  constructor(protected store: ProgramCategoryListStore) {
    super(store);
  }
}
